import type { IVehicleMeterReadingEntryForm } from '@/interfaces'
import type { IDecimalValueAndUnit } from '@/interfaces/IDecimalValueAndUnit'
import DecimalValueAndUnit from '../DecimalValueAndUnit'

class VehicleMeterReadingEntryForm implements IVehicleMeterReadingEntryForm {
  timestamp: string
  machineHours: string
  comments: string
  odometerReading: IDecimalValueAndUnit

  constructor(meterReading?: any) {
    this.timestamp = meterReading?.timestamp
    this.machineHours = meterReading?.machineHours
    this.comments = meterReading?.comments
    this.odometerReading = new DecimalValueAndUnit(meterReading?.odometerReading)
  }
}

export default VehicleMeterReadingEntryForm
